import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ServiceApi } from "../../services/index.service";
import { Backdrop, Button, Paper, Grid, CircularProgress, Link, IconButton, Table, TableBody, TableCell, TableHead, TableRow, ThemeProvider, createTheme } from "@mui/material";

import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { OrderManagement } from "./OrderManagement";
import { RadioButton } from "../shared/RadioButton";
import FlavorsList from "../FlavorsList";

const rootElement = document.getElementById("root");
const theme = createTheme({
    components: {
        MuiDialog: {
            defaultProps: {
                container: rootElement,
            },
        },
    },
});


const CateringPortalTabs = [
    { label: 'Order Management', value: 'order-management' },
    { label: 'Flavor Management', value: 'flavor-management' }
];

const CateringPortal = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [currentTab, setCurrentTab] = useState('order-management');

    useEffect(() => {
        if (pathname)
            setCurrentTab(pathname.split('/').at(-1));
    }, [pathname]);

    const handleTabSelection = (value) => {
        navigate(`/catering-portal/${value}`);
    }

    return (
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4 mt-16">
            <h1 className="text-xl font-display font-medium leading-tight text-secondary mb-4">
                Catering Portal
            </h1>
            {CateringPortalTabs.map(({ label, value }, i) => (
                <RadioButton
                    key={i} label={label} type={value}
                    isSelected={currentTab === value} onClick={() => handleTabSelection(value)} />
            ))}
            <Routes>
                <Route path="order-management" element={<OrderManagement />} key={'orders'} index />
                <Route path="flavor-management" element={<FlavorsList catering />} key={'flavors'} />
                <Route path="*" element={<Navigate to="/catering-portal/order-management" />} />
            </Routes>
        </div >
    )
}

export default CateringPortal;
